module.exports = __webpack_public_path__ + "static/media/12UNCTAD16.56f353c3.jpg";